module.exports = (video) => {
  const { gist = {}, creditBlocks = [], categories = [] } = video

  const CREDIT_KEYS = {
    'director': 'directorName',
    'starring': 'actorName'
  }

  function renderContentType() {
    if (gist.isTrailer) {
      return 'Trailer'
    } else if (gist.mediaType === 'EPISODIC') {
      return 'Episode'
    } else if (gist.contentType === 'SERIES') {
      return 'Show'
    } else {
      return 'Video'
    }
  }

  const videoData = {
    contentId: gist.id,
    contentTitle: gist.title,
    contentType: renderContentType(),
    contentDuration: gist.runtime,
    playbackType: 'Streamed'
  }

  if (creditBlocks.length) { 
    creditBlocks.forEach(creditBlock => {
      const title = creditBlock.title.trim().toLowerCase()
      videoData[CREDIT_KEYS[title]] = creditBlock.credits && creditBlock.credits.map(it => it.title).join(',')
    })
  }
  
  if (categories) {
    categories.push(gist.primaryCategory)
    videoData.contentGenre = categories.map(category => category && category.title).join(',')
  }

  return videoData
}